import React from "react";

const Footer = () => {
  return (
    <div>
      <small>Copyright coming soon</small>
    </div>
  );
};

export default Footer;
